import React from 'react';
import './VolumeDirect.scss';
import { Product } from '../../../../Models/Product';
import { ReactComponent as Arrow } from '../../../Assets/icons/buttonArrow.svg';
import { Link } from '../../../../Devon/Components/InkyLink';
import { ProductItem } from './ProductItem';

interface Props {
    product: Product;
    type: 'Previous' | 'Next';
}


const VolumeDirect = ({ product, type }: Props) => {
    if (!product) {
        return null;
    }


    return (
        <div className='volume-direct-item-container'>
            <Link to={'/product/' + (product.readableUrl ?? product.id)} className='action-wrapper'>
                <Arrow className={type === 'Previous' && 'arrow-reverse'} />
                <span className='next-previous-volume'>{type} volume</span>
            </Link>
            <ProductItem product={product} includeSeriesName fromWheels />
        </div>
    );
};

export default VolumeDirect;
